<template>
  <v-container grid-list-xs>
      <v-col cols="12" :key="key" v-for="(item,key) in testCollection">
      <v-card>
          <v-card-title>
              <h1>{{item.descrizione}}</h1>
          </v-card-title>
          <v-card-subtitle>
            APIKEYHR {{item.apikeyhr}}
            <v-btn flat @click="$emit('refreshstruttura',item.apikeyhr)"><v-icon>mdi-refresh</v-icon></v-btn>
          </v-card-subtitle>
      
      <v-card-text>  
      <v-col cols="12" >
        <testi v-model="item.info"></testi>
      </v-col>
      <v-col cols="12" >
          Gallerie
      </v-col>
      <v-col cols="10" offset="1" v-for="(galleria, indexgal) in item.gallerie" :key="indexgal">

          <v-card>
              <v-card-title>
                {{galleria.titolo}}
              </v-card-title>
              <v-card-subtitle>
                {{galleria.immagini.length}} immagini
              </v-card-subtitle>
              <v-card-text>
                <editorgalleria :admin="true" v-model="item.gallerie[indexgal].immagini"/>
              </v-card-text>
          </v-card>
      </v-col>
      <v-col cols="12" >
          Anagrafica
      </v-col>
      <v-col cols="11" >
          Templates
      </v-col>
      <v-col cols="1">
        <v-btn @click="createmplate()">Crea template</v-btn>
      </v-col>
      <v-col cols="10" offset="1" v-for="(template, indexgal) in templates" :key="indexgal">

          <v-card>
              <v-card-title>
                {{template.descrizionetemplate}}
              </v-card-title>
              <v-card-subtitle>
                {{indexgal}}
              </v-card-subtitle>
              <v-card-actions>
                <v-btn @click="deletetemplate(indexgal)"><v-icon>mdi-delete</v-icon></v-btn>
              </v-card-actions>
          </v-card>
      </v-col>
      </v-card-text>
      <v-card-actions>
          <v-btn @click="salva(item)">Salva</v-btn>
      </v-card-actions>
      </v-card>
      </v-col>
  </v-container>

</template>

<script>
import firebase from "firebase";
import Testi from "@/components/Testi.vue";
import EditorGalleria from "@/components/EditorGalleria.vue";


export default {
  components:{
    testi : Testi,
    editorgalleria:EditorGalleria
  },
  name: 'Home',
  props:['idcliente'],
  data:()=>({
      testCollection: [],
      curritem:null
  }),
  computed:{
    templates(){
      return this.$store.state.templates.data
    }
  },
  methods:{
  createmplate(){
   let dati= {
        idcliente:'',
        id:'',
        descrizionetemplate:'template base'
    }
    this.$store.dispatch("saveAsTemplate",dati)
  },
  deletetemplate(idtemplate){
    console.log("delete",idtemplate)
    this.$store.dispatch("templates/delete",idtemplate)
  },
  salva(item){
      const db = this.$firebase.firestore();
      item.data.idcliente = firebase.auth().currentUser.uid;
      if(item.id){
        db.collection("strutture").doc(item.id)
          .set(item.data,{ merge: true });
      }
      else{
        db.collection("strutture")
          .add(item.data)
          .then(data=> {
            item = data
          });
      }


    }
  },
  mounted() {
    console.log("strutture di",firebase.auth().currentUser.uid)
    this.$store.dispatch('strutture/fetchAndAdd',{ where: [['idcliente', '==', firebase.auth().currentUser.uid]]})
    .then(stutture=>{
      console.log(stutture)
      console.log(this.$store.state.strutture.data)
      this.testCollection =this.$store.state.strutture.data
    })
    /*
    let me = this;
    const db = this.$firebase.firestore();
    db.collection("strutture")
    .where("idcliente", "==", firebase.auth().currentUser.uid)
    .onSnapshot(function(querySnapshot) {
      me.testCollection =[];
            querySnapshot.forEach(function(doc) {
                me.testCollection.push({id:doc.id,data:doc.data()});
            });
            })

       */     
  }
}
</script>
